module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("blsQ0"))).then(() => module.bundle.root('ikE14'));